export const TargetingSlideoverVariant = {
  MANUAL: "manual",
  CSV: "csv",
  PENDING_PARTICIPANTS: "pending_participants",
  OUTREACH_PARTICIPANTS: "outreach_participants",
} as const;
export type TargetingSlideoverVariant =
  (typeof TargetingSlideoverVariant)[keyof typeof TargetingSlideoverVariant];

export interface TargetingContact {
  email: string;
  first_name: string | null;
  last_name: string | null;
  activity_summary?: string[];
}
